var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrayPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6959 14.7607C16.8084 14.6858 16.9378 14.6402 17.0724 14.6279C17.207 14.6157 17.3425 14.6372 17.4667 14.6906L22.2564 16.8366C22.4178 16.9056 22.5526 17.025 22.6404 17.177C22.7283 17.3289 22.7646 17.5053 22.7439 17.6796C22.5861 18.8588 22.0054 19.9405 21.1098 20.7237C20.2142 21.5068 19.0647 21.938 17.875 21.9371C14.2117 21.9371 10.6984 20.4818 8.10809 17.8915C5.51774 15.3011 4.0625 11.7879 4.0625 8.12458C4.06159 6.93488 4.4928 5.78534 5.27593 4.88975C6.05906 3.99415 7.14081 3.41346 8.32 3.25567C8.49432 3.23497 8.67065 3.27127 8.82261 3.35915C8.97457 3.44703 9.09398 3.58176 9.16297 3.74317L11.309 8.53692C11.3617 8.66005 11.3832 8.7943 11.3715 8.92772C11.3598 9.06115 11.3153 9.18962 11.242 9.30169L9.07156 11.8824C8.99458 11.9986 8.94905 12.1327 8.93944 12.2718C8.92982 12.4108 8.95645 12.5499 9.01672 12.6756C9.85664 14.3951 11.634 16.1511 13.3585 16.9829C13.4848 17.0429 13.6246 17.0689 13.7641 17.0584C13.9035 17.0479 14.0378 17.0012 14.1538 16.9229L16.6959 14.7607Z",
    stroke: "#666666",
    strokeWidth: 1.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrayPhone);
export default __webpack_public_path__ + "static/media/IconGrayPhone.9169c75cbe98c6ff323f297eb83ad098.svg";
export { ForwardRef as ReactComponent };